import React from 'react';
import { GRAPHQL_LOCALE_CODE_TO_REST_LOCALE_CODE_MAP_FOR_MEMBERS_PG_SCHEDULE_HELPERS } from '@peloton/internationalize/consolidatedAppConfigs/models';
import { useReduxState, useReduxAction } from '@engage/redux/hooks';
import type { PendingInviteCountQuery } from '@members/graphql-swr/schemas/scheduled-classes/queries/PendingInviteCount.generated';
import type { YourScheduleItemsQuery } from '@members/graphql-swr/schemas/scheduled-classes/queries/YourScheduleItems.generated';
import { LocaleCode } from '@members/graphql-swr/types.generated';
import { useRemoveClassFromScheduleMutationSWR } from '../hooks/useRemoveClassFromScheduleMutationSWR';
import { getNumOfPendingInvites, setNumOfPendingInvites } from '../redux';

export const useRemoveScheduleById = (id: string | undefined) => {
  const {
    removeClassFromScheduleMutation,
    isLoading: isRemoveClassLoading,
    error: removeClassError,
  } = useRemoveClassFromScheduleMutationSWR();

  const removeFromClassAction = React.useCallback(
    () =>
      removeClassFromScheduleMutation({
        id: id || '',
      }),
    [id, removeClassFromScheduleMutation],
  );

  return {
    removeClassFromScheduleMutation,
    removeFromClassAction,
    isRemoveClassLoading,
    removeClassError,
  };
};

export const formatGraphqlLocale = (localeCode: LocaleCode = LocaleCode.EsUs) =>
  // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'LocaleCode' can't be used to index type '{ EN_US: Locale; DE_DE: Locale; DE_AT: Locale; EN_AU: Locale; EN_GB: Locale; EN_CA: Locale; UZ_UZ: Locale; ES_MX: Locale; }'.
  GRAPHQL_LOCALE_CODE_TO_REST_LOCALE_CODE_MAP_FOR_MEMBERS_PG_SCHEDULE_HELPERS[localeCode];

export const useManagePendingInvites = (
  data: YourScheduleItemsQuery | PendingInviteCountQuery | undefined,
) => {
  const numOfPendingInvites = useReduxState(getNumOfPendingInvites);
  const setPendingInvitesAction = useReduxAction(setNumOfPendingInvites);
  const valueToShow = numOfPendingInvites > 99 ? 99 : numOfPendingInvites;

  React.useEffect(() => {
    if (data?.userScheduledItemsList?.__typename === 'YourScheduleItemList') {
      const itemList = data?.userScheduledItemsList?.pendingInvites;
      if (itemList.__typename === 'PendingInvites') {
        setPendingInvitesAction(itemList.countOfPendingInvites);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    valueToShow,
    numOfPendingInvites,
  };
};
